import { LandingPageHeroTitle } from 'components/landingPageHero/LandingPageHeroTitle'
import { LandingPageTextImageButton } from 'components/landingPageTextImageSection/LandingPageTextImageButton'
import { LandingPageTextImagePerks } from 'components/landingPageTextImageSection/LandingPageTextImagePerks'
import { LandingPageTextImageSection } from 'components/landingPageTextImageSection/LandingPageTextImageSection'
import { colors } from 'utils/colors'

import CyberscoutLogo from 'images/extra-svg/CyberscoutLogoThemedSection.svg'
import { useTranslation } from 'next-i18next'
import { mapKeysToTrans } from 'utils/i18n/mapKeysToTrans'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { useAuth } from 'utils/auth/hooks/useAuth'
import { numberRange } from 'utils/general'

export function CyberscoutHeroSection() {
  const { isLogged } = useAuth()
  const { t } = useTranslation('cyberscout')
  const images = useContentfulImages()
  const ctaUrl = isLogged ? '/me/dashboard?cyberscout=true' : '/signup'

  const perks = mapKeysToTrans(
    t,
    numberRange(5).map((i) => `cyberscout.hero.perk_${i}` as const)
  )

  return (
    <LandingPageTextImageSection
      image={images.cyberscout_hero}
      mobileImage={images.cyberscout_hero_mobile}
      icon={<CyberscoutLogo />}
      title={<LandingPageHeroTitle title={t('cyberscout.hero.title')} />}
      backgroundColor={colors.gray[50]}
    >
      <LandingPageTextImagePerks perks={perks} />
      <LandingPageTextImageButton href={ctaUrl} size="large" tone="dark">
        {t('cyberscout.hero.cta')}
      </LandingPageTextImageButton>
    </LandingPageTextImageSection>
  )
}
